import React from "react";
import ReactGA from "react-ga";
import _ from "lodash";
import { getCurrentPage } from "../helpers";
import {
    AreaChart,
    Area,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
} from "recharts";

class ElevationGraph extends React.Component {
    state = {
        shown: this.props.currentJourney.currentJourney ? true : false,
        mobile: window.innerWidth > 450 ? false : true,
        location: {
            lat: 51.454549,
            lng: -2.587919,
        },
        currentIndex: null,
    };

    showHide = (e, force = false) => {
        e && e.preventDefault();

        // GA Track (only on click)
        if (force === false) {
            ReactGA.event({
                category: _.startCase(getCurrentPage()),
                action: "Toggle elevation graph",
                label: !this.state.shown ? "Show" : "Hide",
            });
        }

        this.setState({
            shown: force ? force : !this.state.shown,
        });
    };

    handleChange = (moveInfo, data) => {
        if (moveInfo.isTooltipActive) {
            const currentIndex = moveInfo.activeTooltipIndex;
            const newIndex = !_.isEqual(this.state.currentIndex, currentIndex);
            const location = data[currentIndex].location;

            if (newIndex) {
                this.setState(
                    {
                        location,
                        currentIndex,
                    },
                    () => {
                        this.setMarker(this.state.location, true);
                    }
                );
            }
        } else {
            this.setMarker(this.state.location, false);
        }
    };

    setMarker = (location, show = false) => {
        // Move marker
        const marker = {
            location: {
                lat: location.lat,
                lng: location.lng,
            },
            icon: {
                url: `${window.ROOT}${window.PORT}/images/markers/map_waypoint.png`,
                size: { width: 19, height: 19 },
                scaledSize: { width: 12, height: 12 },
                anchor: { x: 6, y: 6 },
            },
        };

        const markers = [marker];

        if (show) {
            marker.visible = true;
        } else {
            marker.visible = false;
        }

        this.props.addMarkers("elevationGraph", markers);
    };

    componentDidMount() {
        // Add marker to be moved later by elevation graph
        this.setMarker(this.state.location, false);
    }

    componentWillUnmount() {
        this.props.removeMarkers("elevationGraph");
    }

    render() {
        const current = this.props.currentJourney.currentJourney;

        return (
            <div
                className={`elevation-graph isShown-${this.state.shown}`}
                aria-hidden="true"
            >
                <div className="elevation-graph-wrapper">
                    {current && (
                        <ElevationGraphBody
                            data={
                                this.props.cycleRoutes[current].elevation_graph
                            }
                            elevationMax={this.props.cycleRoutes.elevationMax}
                            handleChange={this.handleChange}
                            mobile={this.state.mobile}
                        />
                    )}
                </div>
            </div>
        );
    }
}

const ElevationGraphBody = ({ data, elevationMax, handleChange, mobile }) => {
    return (
        <div className="elevation-graph-body">
            <AreaChart
                width={mobile ? 280 : 400}
                height={175}
                margin={{ top: 25 }}
                data={data}
                onMouseMove={(e) => handleChange(e, data)}
                onMouseLeave={(e) => handleChange(e, data)}
            >
                <CartesianGrid />
                <XAxis
                    dataKey="distance"
                    interval={Math.round(data.length / 10)}
                    height={30}
                    label={<XLabel mobile={mobile ? 280 : 400} />}
                />
                <YAxis
                    dataKey="elevation"
                    width={20}
                    label={<YLabel />}
                    domain={[0, elevationMax > 100 ? elevationMax : 100]}
                />
                <Area
                    type="linear"
                    dataKey="elevation"
                    fill="#D5E3E6"
                    stroke="#013852"
                    strokeWidth={3}
                    dot={false}
                />
                <Tooltip cursor={{ stroke: "#336b92", strokeWidth: 1 }} />
            </AreaChart>
        </div>
    );
};

const XLabel = ({ mobile }) => (
    <text
        stroke="none"
        x={mobile}
        y={175}
        className="elevation-graph-label elevation-graph-label-x-axis"
        fill="#4d4d4d"
        textAnchor="end"
    >
        <tspan>Distance</tspan> (miles)
    </text>
);
const YLabel = () => (
    <text
        stroke="none"
        x={0}
        y={10}
        className="elevation-graph-label elevation-graph-label-y-axis"
        fill="#4d4d4d"
        textAnchor="start"
    >
        <tspan>Elevation</tspan> (m)
    </text>
);

export default ElevationGraph;



// WEBPACK FOOTER //
// ./src/components/ElevationGraph.js